/**
 * Why a billing run does not start (#1618).
 *
 * ⚠ **An API contract, not a text.** The code travels over HTTP, the sentence
 * for it stands in the frontend. A sentence on the wire would be a copy change
 * needing a server release, and a frontend that had to read and branch on it to
 * put the *"Zur Einstellung"* link beside it, say — that is a second, unspoken
 * contract about the letters of a German sentence.
 *
 * ⚠ **Open for later waves.** The AV contract v3 and the Echtzulassung go into
 * the same collector (TM-9637 / TM-9638). An extension is a new value here; a
 * frontend that does not know it yet shows the fallback text and not nothing.
 */
export var GkvRunRefusalReasonCode;
(function (GkvRunRefusalReasonCode) {
    /** No record, and no Absender IK of its own. */
    GkvRunRefusalReasonCode["NO_ABSENDER"] = "NO_ABSENDER";
    /** *entwurf* — accepted, but Therame has not identified yet. */
    GkvRunRefusalReasonCode["IDENTITY_NOT_VERIFIED"] = "IDENTITY_NOT_VERIFIED";
    /** *vereinbart* — the beginning still lies ahead. */
    GkvRunRefusalReasonCode["BEAUFTRAGUNG_NOT_YET_EFFECTIVE"] = "BEAUFTRAGUNG_NOT_YET_EFFECTIVE";
    /** *beendet* — the end lies behind us. */
    GkvRunRefusalReasonCode["BEAUFTRAGUNG_ENDED"] = "BEAUFTRAGUNG_ENDED";
    /** In force, but under a version no run starts under any more. */
    GkvRunRefusalReasonCode["TERMS_OUTDATED"] = "TERMS_OUTDATED";
    /** In force, but this installation names no usable Therame IK. */
    GkvRunRefusalReasonCode["THERAME_IK_NOT_CONFIGURED"] = "THERAME_IK_NOT_CONFIGURED";
    /** The Standort's own Absender IK does not pass its check. */
    GkvRunRefusalReasonCode["ABSENDER_IK_INVALID"] = "ABSENDER_IK_INVALID";
    /**
     * A selected case carries a character in a text field that ISO 8859-1 cannot
     * carry and the text clean-up has no spelling for — an emoji, a Cyrillic
     * letter (#1954).
     *
     * ⚠ **The first reason that hangs off a case and not off the Standort's
     * setup.** It still belongs in this list rather than in a skip of the case:
     * the practice selected the case to bill it, and a run that quietly left it
     * out would report a success it did not have. Fixing the field is the action,
     * and the run starts afterwards.
     */
    GkvRunRefusalReasonCode["CHARACTER_NOT_REPRESENTABLE"] = "CHARACTER_NOT_REPRESENTABLE";
})(GkvRunRefusalReasonCode || (GkvRunRefusalReasonCode = {}));
/**
 * The error code of the 422 the list arrives under.
 *
 * It tells this response apart from every other start refusal — the empty
 * selection, the stale candidate tree, the run already in flight. Those stay a
 * toast; only this one becomes a list.
 */
export const GKV_RUN_REFUSED = 'GKV_RUN_REFUSED';
//# sourceMappingURL=gkv-run-refusal-reason.enum.js.map